import * as React from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { WAYPOINT_TYPE_CUSTOMER, WAYPOINT_TYPE_PRIVATE } from '../Waypoints/constants';
import './waypointCluster.scss';
import { isWaypointsOpenAtom } from '../Waypoints/WaypointState';
import { autofocusAtom } from '../OnlineMapState';
import useAnalytics from '../../../hooks/useAnalytics';

interface IWaypointClusterProps {
  clusterId: string;
  items: number;
  lat: number; // lat is used by OverlayView in GoogleMapsReactMarkers package
  lng: number; // lng is used by OverlayView in GoogleMapsReactMarkers package
  expansionZoom: number;
  googleMap: google.maps.Map | undefined;
  zIndex: number; // zIndex is used by OverlayView in GoogleMapsReactMarkers package
  waypointsType: string[];
}

export default function WaypointCluster(props: IWaypointClusterProps) {
  const setAutofocus = useSetRecoilState<boolean>(autofocusAtom);
  const isWaypointsOpen = useRecoilValue(isWaypointsOpenAtom);
  const [isTooltipOpen, toggleIsTooltipOpen] = React.useReducer((state: boolean) => {
    return !state;
  }, false);
  const elementRef = React.useRef<HTMLDivElement | null>(null);
  const { trackEvent } = useAnalytics();

  const handleOnClick = (_event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    if (props.googleMap) {
      trackEvent(['map', 'click', 'Click waypoint cluster on map']);
      props.googleMap.setZoom(props.expansionZoom);
      props.googleMap.panTo({ lat: props.lat, lng: props.lng });
      setAutofocus(false);
    }
  };

  React.useEffect(() => {
    if (elementRef.current) {
      const markerElement = elementRef.current.parentElement;
      if (markerElement) {
        if (isTooltipOpen) {
          markerElement.style.zIndex = String(props.zIndex + 10000000000);
        } else {
          markerElement.style.zIndex = String(props.zIndex);
        }
      }
    }
  }, [isTooltipOpen, props.zIndex]);

  const countPrivateWPType = props.waypointsType.filter(
    (item) => item === WAYPOINT_TYPE_PRIVATE
  ).length;
  const countCustomerWpType = props.waypointsType.filter(
    (item) => item === WAYPOINT_TYPE_CUSTOMER
  ).length;

  return (
    <div
      id={`cluster-${props.clusterId}`}
      onClick={handleOnClick}
      style={{
        cursor: 'pointer',
        zIndex: Number(props.zIndex),
        opacity: 1,
      }}
      onMouseEnter={toggleIsTooltipOpen}
      onMouseLeave={toggleIsTooltipOpen}
      ref={elementRef}
    >
      <div className="waypoint-cluster-icon">{props.items}</div>
      {isTooltipOpen && (
        <div
          className="b-waypoint-cluster-list"
          style={{
            zIndex: props.zIndex,
            position: 'absolute',
            top: -1,
            transform:
              countCustomerWpType > 0 && countPrivateWPType > 0
                ? 'translate(30%, 100%)'
                : 'translate(30%, 150%)',
          }}
        >
          <div className="b-waypoint-cluster-list-items">
            {countCustomerWpType > 0 && (
              <a href="#" className="cluster-item-customer">
                <span className="cluster-item-private-name">Zákaznícke:</span>
                {countCustomerWpType}
              </a>
            )}
            {countPrivateWPType > 0 && (
              <a href="#" className="cluster-item-private">
                <span className="cluster-item-private-name">Súkromné:</span>
                {countPrivateWPType}
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
